import React from 'react';

export default function Pager({ page, totalPages, onChange }) {
    if (totalPages <= 1) return null;

    return (
        <div className="columns is-centered" style={{ marginTop: '1rem' }}>
            <div className="column is-narrow" style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <button
                    type="button"
                    className="button"
                    disabled={page <= 1}
                    onClick={() => onChange(page - 1)}
                >
                    Anterior
                </button>
                <span>Página {page} de {totalPages}</span>
                <button
                    type="button"
                    className="button"
                    disabled={page >= totalPages}
                    onClick={() => onChange(page + 1)}
                >
                    Siguiente
                </button>
            </div>
        </div>
    );
}
